// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Nx-z","itemsContainer":"Ox-z"};